// extracted by mini-css-extract-plugin
export default {"pageContainer_txdis":"TexasDisclosure_pageContainer_txdis__fPpqi","hero_image_txdis":"TexasDisclosure_hero_image_txdis__30uKJ","heading_txdis":"TexasDisclosure_heading_txdis__W-GdA"};